import React from 'react';
import logo from './logo.svg';
import './App.css';
import Wrapper from './components/wrapper';
import * as Sentry from '@sentry/react'


Sentry.init({
  dsn: 'https://fde4d5f31be69074e32ccaa945a66895@o4504156787507200.ingest.sentry.io/4506223223767040',
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

function App() {
  return (
    <div className="App">
      <Wrapper />
    </div>
  );
}

export default App;
